import { SupportedEnvironments } from '@/config/environment';
import { NaluriChatError } from '@/errors';

export function getGatewayEndpoint(environment: SupportedEnvironments) {
  switch (environment) {
    case SupportedEnvironments.DEV:
      return 'https://chat-gateway.dev.naluri.net';
    case SupportedEnvironments.SIT:
      return 'https://chat-gateway.staging.naluri.net';
    case SupportedEnvironments.PROD:
      return 'https://chat-gateway.naluri.net';
    default:
      throw new NaluriChatError({
        message: `Environment is not supported.`,
        code: '4010',
      });
  }
}
